export const environment = {
  production: false,
  apiUrl: 'https://9gjwrzted8.execute-api.eu-central-1.amazonaws.com/staging/',
  patreonUrl: "https://www.patreon.com/oauth2/authorize?" +
    "response_type=code&" +
    "client_id=aVsLtLo4zdBlNoBChgYH3tHK-MGFXFEqXwAde6DGDZREsxET4bqoqRFGuuXVxbdS&" +
    "redirect_uri=https%3A%2F%2Fstaging.tippspiel-spotfight.de%2Fhome%2Foauth%2Fv2%2Fpatreon&" +
    "scope=identity%20identity%5Bemail%5D&" +
    "state=asakfjhdjklhjasdgjklfadklgj",
  googleUrl: "https://accounts.google.com/o/oauth2/v2/auth?" +
    "client_id=865328329789-9hhmj32h9rd0g0k431p8cnqrs739mj1m.apps.googleusercontent.com&" +
    "redirect_uri=https://staging.tippspiel-spotfight.de/home/oauth/v2/google&" +
    "response_type=code&" +
    "scope=https://www.googleapis.com/auth/youtube.readonly&" +
    "access_type=offline",
  version: "v1.4.0"
};
